import React from 'react';
import { useSelector } from 'react-redux';
import { useAccountDistributionOrderQuery } from '../AccountDistributionOrderModal/api/useAccountDistributionOptionsQuery';
import { ErrorState } from '../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Loading } from '../CommonComponents/OPL/Loading/Loading';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { selectCurrentClient } from '../CommonSelectors/CommonAreaSelector';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';
import { ClientSettingsForm } from './components/ClientSettingsForm/ClientSettingsForm';
import { useClientSettings } from './useClientSettings';

export const ClientSettings = () => {
  useDocumentTitle('Client Settings');

  const client = useSelector(selectCurrentClient);

  const { isLoading, isError, refetch, data } = useClientSettings();

  const {
    data: accountDistributionOrder,
    isLoading: isLoadingAccountDistributionOrder,
    isError: isErrorAccountDistributionOrder,
    refetch: refetchAccountDistributionOrder,
  } = useAccountDistributionOrderQuery(client.Id);

  if (isLoading || isLoadingAccountDistributionOrder) {
    return (
      <Box alignItems="center" display="flex" height="100%" justifyContent="center" width="100%">
        <Loading text="Loading..." />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box my="56">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (isErrorAccountDistributionOrder) {
    return (
      <Box my="56">
        <ErrorState onAction={refetchAccountDistributionOrder} />
      </Box>
    );
  }

  if (!data || !accountDistributionOrder) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Text as="h1" fontWeight={600} color="neutral.600" fontSize="h3" mb="24">
        Client Settings
      </Text>

      <Box
        borderBottom="1px solid"
        borderColor="neutral.200"
        mb="24"
        display="flex"
        justifyContent="space-between"
      >
        <Text as="h2" fontSize="h4" fontWeight={600} mb="8">
          Assumptions
        </Text>
      </Box>

      <ClientSettingsForm data={data} accountDistributionOrder={accountDistributionOrder} />
    </Box>
  );
};
